
import React from 'react';
import { Interview } from '@/types/interview';
import ViewInterviewDialog from '@/components/interview/ViewInterviewDialog';
import EditInterviewDialog from '@/components/interview/EditInterviewDialog';

interface InterviewDialogsProps {
  selectedInterview: Interview | null;
  isViewDialogOpen: boolean;
  isEditDialogOpen: boolean;
  handleCloseViewDialog: () => void;
  handleCloseEditDialog: () => void;
  onPublish: (interviewId: string) => Promise<void>;
  onSendToFeeder: (interviewId: string) => Promise<void>;
  publishingId: string | null;
}

const InterviewDialogs: React.FC<InterviewDialogsProps> = ({
  selectedInterview,
  isViewDialogOpen,
  isEditDialogOpen,
  handleCloseViewDialog,
  handleCloseEditDialog,
  onPublish,
  onSendToFeeder,
  publishingId,
}) => {
  return (
    <>
      <ViewInterviewDialog 
        interview={selectedInterview}
        isOpen={isViewDialogOpen}
        onClose={handleCloseViewDialog}
        onPublish={onPublish}
        onSendToFeeder={onSendToFeeder}
        publishingId={publishingId}
        sendingToFeederId={null}
      />

      <EditInterviewDialog 
        interview={selectedInterview}
        isOpen={isEditDialogOpen}
        onClose={handleCloseEditDialog}
      />
    </>
  );
};

export default InterviewDialogs;
